import { t as translateDate } from './translate-date.js';
import './index2.js';

/*
 * Blastness
 */
function factory({ window, document, thn }) {
    const engine = {};
    const isBookingEngine = window.location.pathname.match(/reservations|reservation_hotel.htm/);
    const GRAND_HOTEL_MIRAMARE_PID = 1036330;
    const MIRAMARE_SESTRI_PID = 1036327;
    const ROYAL_HOTEL_SANRENO_PID = 1036329;
    const BORGO_SCOPETO_PID = 1028386;
    const DESIO_CHARMING_UID = 1042294;
    const FIRENZE_CONTINENTALE_PID = 1036328;
    const HOTEL_DE_LA_PAIX_PID = 1038759;
    const HOTEL_LORD_BYRON = 1040890;
    const HOTEL_REGENCY_FIRENZE = 1040892;
    let refreshBooking;
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            let lang;
            if (thn.data.propertyId === GRAND_HOTEL_MIRAMARE_PID) {
                lang = window.location.pathname.split('/')[1] === 'en' ? 'en' : 'it';
            }
            if (thn.data.propertyId === MIRAMARE_SESTRI_PID) {
                lang = window.location.pathname.split('/')[1] === 'it' ? 'it' : 'en';
            }
            // Palace Hotel Viareggio
            if (thn.data.propertyId === 1158070) {
                lang = window.location.pathname.split('/')?.[1] !== '' ? window.location.pathname.split('/')?.[1] : 'it';
            }
            // Hotel Grifone Firenze | Cignella
            if ([1037418, 1043905].includes(thn.data.accountUserId)) {
                lang = document.querySelector('.titolo-lingua')?.textContent;
                lang = lang && lang.substr(0, 2);
            }
            // Tridente Collection
            if (thn.data.accountUserId === 1040518) {
                lang = (document.querySelector('.language-switcher a') || {}).textContent;
            }
            // Trinity Luxury Rooms | Hotel Balocco
            if ([1039462, 1038483].includes(thn.data.accountUserId)) {
                lang = (document.querySelector('.select-lingue span') || {}).textContent;
            }
            if ([BORGO_SCOPETO_PID, FIRENZE_CONTINENTALE_PID].includes(thn.data.propertyId) || thn.data.accountUserId === DESIO_CHARMING_UID) {
                lang = document.querySelector('#lang')?.value;
            }
            if (isBookingEngine) {
                lang = thn.parseUrlParameter('lingua_int')?.substr(0, 2) || document.querySelector('li.selected')?.getAttribute('data-language')?.slice(0, 2) || document.querySelector('#summary-body')?.getAttribute('class')?.split('_')[1]?.slice(0, 2);
            }
            if (thn.data.propertyId === ROYAL_HOTEL_SANRENO_PID || (isBookingEngine && thn.data.propertyId === HOTEL_DE_LA_PAIX_PID)) {
                lang = document.body.className.slice(5, 7);
            }
            if ([HOTEL_LORD_BYRON, HOTEL_REGENCY_FIRENZE].includes(thn.data.propertyId) && !isBookingEngine) {
                lang = document.querySelector('meta[property="og:locale"]')?.content?.slice(0, 2);
            }
            if (lang && ctx.langs.test(lang)) {
                resolve(lang);
                return;
            }
            reject('no_language');
        });
    };
    /**
     * @memberOf module:bs_98
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        // dictionary for languages
        const langDictionary = {
            en: 'eng',
            it: 'ita',
        };
        // https://www.blastnessbooking.com/reservations/risultato.html?id_stile=18499&id_albergo=19125&dc=7849&lingua_int=eng&gg=29&mm=01&aa=2024&tot_adulti=2&tot_camere=1&tot_bambini=0&notti_1=1
        const url = new URL(ctx.baseUrl);
        const validUrl = url.pathname.match(/reservations/);
        if (!validUrl) {
            ctx.newUrl = '';
            return ctx;
        }
        url.searchParams.set('lingua_int', langDictionary[thn.data.language]);
        // Export into ctx.newUrl
        ctx.newUrl = url.toString();
        return ctx;
    };
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const pricePerNightBlacklist = [1041270, 1042294].includes(thn.data.accountUserId);
        const summary = document.querySelector('.blocchetto_prenotazione, #mini-header');
        const risultatos = summary?.querySelectorAll('.risultato, .value-data');
        const dateBegin = risultatos?.length > 1 && translateDate(risultatos[0].textContent, thn.data.language);
        const dateEnd = risultatos?.length > 1 && translateDate(risultatos[1].textContent, thn.data.language);
        let nights = 0;
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(dateBegin, dateEnd);
        }
        const roomsData = [...document.querySelectorAll('.row_tariffa[class*=id_]:not(.product-info), .room-box')].map((roomData) => {
            const room = roomData.querySelector('.reserve-button');
            const price = thn.parseNumber((roomData.querySelector('.prezzo, .price') || {}).textContent);
            const currency = thn.parseCurrency((roomData.querySelector('.prezzo, .valuta') || {}).textContent);
            const adults = (room && thn.parseNumber(room.getAttribute('data-adulti'))) || thn.parseNumber(roomData.querySelector('.guests-adults')?.textContent) || 2;
            const children = (room && thn.parseNumber(room.getAttribute('data-bambini'))) || thn.parseNumber(roomData.querySelector('.guests-children')?.textContent) || 0;
            return {
                adults: adults,
                children: children,
                price: price,
                currency: currency,
            };
        }).filter((room) => (room.price && room.currency)).sort((a, b) => a.price - b.price);
        if (!thn.empty(roomsData) && nights) {
            widgetData.adults = roomsData[0].adults;
            widgetData.children = roomsData[0].children;
            widgetData.guests = widgetData.adults + widgetData.children;
            widgetData.price = pricePerNightBlacklist ? roomsData[0].price : roomsData[0].price / nights;
            widgetData.currency = roomsData[0].currency;
            widgetData.set = true;
        }
        else {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    engine.bookingObserveDom = function bookingObserveDom(ctx) {
        const container = document.querySelector('.contenuto');
        if (container && !refreshBooking && !ctx.widget.isSet()) {
            refreshBooking = thn.debounce(() => {
                if (ctx.widget.setData.isSet()) {
                    ctx.widget.save();
                }
            });
            thn.observeDom(container, refreshBooking, {
                childList: true,
                subTree: true,
                attributes: false,
            });
            thn.pageUnload(() => {
                refreshBooking.cancel();
                thn.stopObserveDom(container, refreshBooking);
                refreshBooking = null;
            });
        }
    };
    /**
       * @memberOf module:bs_98
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const bookingIds = thn.dataLayerHelper.get('transactionId')?.split('-') || [...document.querySelectorAll('#dati-personali .reservation_rooms_details')];
        const roomsData = [...document.querySelectorAll('#summary-box .table')];
        const description = [...roomsData.shift().querySelectorAll('.value-data')];
        const promocode = document.querySelector('div.summary_value.summary_value_corporate')?.textContent;
        const dateBegin = thn.dataLayerHelper.get('checkInDate') || (description?.length > 1 && thn.dateToString(description[0]?.textContent));
        const dateEnd = thn.dataLayerHelper.get('checkOutDate') || (description?.length > 1 && thn.dateToString(description[1]?.textContent));
        if (!thn.empty(roomsData)) {
            const widgetDataMulti = roomsData.map((room, index) => {
                const bookingId = (thn.dataLayerHelper.get('transactionId') && bookingIds?.[index]?.trim()) || ((bookingIds?.[index]?.querySelector('.summary_value_code span') || {}).nextSibling || {}).textContent.trim();
                const prices = room?.querySelectorAll('.summary_value.summary_value_total_room_rate');
                const priceAndCurrency = (prices?.[prices.length - 1] || {}).textContent;
                const guests = (room?.querySelector('.summary_occupancy .summary_value_room') || {}).textContent?.split('-');
                const adults = thn.parseNumber(guests?.[0]) || 2;
                const children = thn.parseNumber(guests?.[1]) || 0;
                const data = {
                    bookingId: bookingId,
                    dateBegin: dateBegin,
                    dateEnd: dateEnd,
                    adults: adults,
                    children: children,
                    guests: adults + children,
                    price: thn.parseNumber(priceAndCurrency),
                    currency: thn.parseCurrency(thn.dataLayerHelper.get('currency') || priceAndCurrency),
                };
                if (promocode) {
                    data.promocode = promocode;
                }
                return data;
            });
            return widgetDataMulti;
        }
        return widgetData;
    };
    return engine;
}

export { factory };
